import { imageMapper } from '~/mappers/image/imageMapper';

import { ImageBlock } from './models';

export const imageBlockMapper = ({ images, caption }: ImageBlock) => ({
  caption: caption || images[0]?.caption || undefined,
  images: images.map((image) => imageMapper(image)),
});
